import { intl } from "LocaleWrapper";
import { useApolloClient } from "@apollo/client";

import { Card, PageHeader, QuickFilterTypes, Table } from "@cofano/cck";

import { TableId, useBackendTable } from "components/table";
import Helmet from "components/helmet/Helmet";

import { DataFormat, Language } from "imports/Utils";

import { SortDirection } from "__generated__/enums";
import { GetContainerTypesBySearchDocument, GetContainerTypesBySearchQuery } from "__generated__/view/containertypes/graphql/containerType.queries.generated";

import { ChildPropsFromPagination } from "types/commons";

type ContainerTypeFromQuery = ChildPropsFromPagination<GetContainerTypesBySearchQuery, "containerTypeSearch">

const ContainerTypes = () => {
	const client = useApolloClient();

	const { tableProps } = useBackendTable({
		id: TableId.ContainerTypes,
		onChange: async (pagination, sort, filter, callback) => {
			try {
				const result = await client.query({
					query: GetContainerTypesBySearchDocument,
					variables: {
						pagination: {
							...pagination,
							sortList: sort ?? [ {
								field: "isoTypeCode",
								direction: SortDirection.Asc,
							} ],
						},
						search: {
							isoTypeCode: filter.isoTypeCode,
							displayCode: filter.displayCode,
							reefer: filter.reefer,
						},
					},
				});

				callback({
					content: result.data.containerTypeSearch.content.map((type, index) => ({ ...type, id: index })),
					totalResults: result.data.containerTypeSearch.totalElements,
				});
			} catch {
				callback({
					content: [],
					totalResults: 0,
				});
			}
		},
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("CONTAINER_TYPES")}
					<Helmet title={intl.formatMessage({ id: "VOYAGES" })} />
				</PageHeader.Title>
			</PageHeader>

			<Card disablePadding>
				<Table
					{...tableProps}
					columns={[ {
						id: "isoTypeCode",
						title: intl.formatMessage({ id: "ISO_CODE" }),
						sortable: true,
						filterComponent: QuickFilterTypes.TEXT,
					}, {
						id: "displayCode",
						title: intl.formatMessage({ id: "DISPLAY_CODE" }),
						defaultVisible: false,
						filterComponent: QuickFilterTypes.TEXT,
					}, {
						id: "reefer",
						title: intl.formatMessage({ id: "REEFER" }),
						render: (row: ContainerTypeFromQuery) => DataFormat.boolean(row.reefer),
						filterComponent: QuickFilterTypes.BOOLEAN,
						sortable: true,
					}, {
						id: "lengthFt",
						title: intl.formatMessage({ id: "LENGTH" }),
						render: (row: ContainerTypeFromQuery) => DataFormat.feet(row.lengthFt),
						sortable: true,
					}, {
						id: "teu",
						title: intl.formatMessage({ id: "TEU" }),
						sortable: true,
					} ]} />
			</Card>
		</div>
	);

};

export default ContainerTypes;


